__turbopack_context__.v({
  "empty": "notificationList-module-scss-module__Oy_93a__empty",
  "fade-in-uboa5f8": "notificationList-module-scss-module__Oy_93a__fade-in-uboa5f8",
  "notification-list": "notificationList-module-scss-module__Oy_93a__notification-list",
  "notification-list-header": "notificationList-module-scss-module__Oy_93a__notification-list-header",
  "report": "notificationList-module-scss-module__Oy_93a__report",
  "toggle": "notificationList-module-scss-module__Oy_93a__toggle",
  "wrapper": "notificationList-module-scss-module__Oy_93a__wrapper",
});
